// =============================================================================
// Copyright : 2026 semantics GmbH
// Purpose   : search module actions
// =============================================================================
import { createAction } from 'redux-actions';
// NL-SQL conversation store, see ./reducers.js
export const nlsqlStoreThread = createAction('NLSQL_STORE_THREAD', (threadId, thread)=>({
        threadId,
        thread
    }));
export const nlsqlDropThread = createAction('NLSQL_DROP_THREAD', (threadId)=>({
        threadId
    }));
export const nlsqlClearThreads = createAction('NLSQL_CLEAR_THREADS');
